import { render, staticRenderFns } from "./IncomesBySectionDonut.vue?vue&type=template&id=68fbb9a0&scoped=true"
import script from "./IncomesBySectionDonut.vue?vue&type=script&lang=js"
export * from "./IncomesBySectionDonut.vue?vue&type=script&lang=js"
import style0 from "./IncomesBySectionDonut.vue?vue&type=style&index=0&id=68fbb9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fbb9a0",
  null
  
)

export default component.exports